import api from '../../../../api/client';

export const GENDER_OPTIONS = [
  { value: 'A', label: 'All' },
  { value: 'M', label: 'Male' },
  { value: 'F', label: 'Female' },
];

export const ACCUMULATE_OPTIONS = [
  { value: 'Yes', label: 'Yes' },
  { value: 'No', label: 'No' },
];

export const SEARCH_FIELD_OPTIONS = [
  { value: 'Name', label: 'Rule Name' },
];

export const STATUS_OPTIONS = [
  { value: 'Active', label: 'Active' },
  { value: 'Inactive', label: 'Inactive' },
  { value: 'All', label: 'All Status' },
];

export const TOOLS_OPTIONS = [
  { key: 'print', label: 'Print Report', icon: 'print' },
  { key: 'export_excel', label: 'Export Excel', icon: 'description' },
  { key: 'export_pdf', label: 'Export PDF', icon: 'picture_as_pdf' },
];

function mapRuleHeader(item) {
  if (!item) return null;
  const isArch = Boolean(item.Archive ?? item.archive);
  return {
    id: item.ID || item.id,
    name: item.Name || item.name || '',
    archive: isArch,
    isDeleted: Boolean(item.IsDeleted ?? item.is_deleted),
    status: item.status || (isArch ? 'Inactive' : 'Active'),
    quotaCount: item.quota_count ?? (item.details?.length || 0),
    details: Array.isArray(item.details) ? item.details.map(mapRuleDetail) : [],
  };
}

function mapRuleDetail(item) {
  if (!item) return null;
  return {
    id: item.ID || item.id,
    ruleId: item.PID || item.pid,
    leaveTypeId: item.LeaveTypeID || item.leave_type_id || item.leaveTypeId,
    leaveTypeName: item.leave_type_name || item.LeaveTypeName || 'Leave',
    leaveTypeAlias: item.leave_type_alias || item.Aliase || '',
    leaveTypeColor: item.leave_type_color || item.ColorCode || '#3B82F6',
    totalDays: Number(item.TotalDays ?? item.total_days ?? 0),
    minDays: Number(item.MinDays ?? item.min_days ?? 0),
    maxDays: Number(item.MaxDays ?? item.max_days ?? 0),
    cfDays: Number(item.CFDays ?? item.cf_days ?? 0),
    accumulate: String(item.Accumulate ?? item.accumulate ?? 'No'),
    lapseDays: Number(item.LapseDays ?? item.lapse_days ?? 0),
    extraDays: Number(item.ExtraDays ?? item.extra_days ?? 0),
    gender: String(item.Gender ?? item.gender ?? 'A').trim().toUpperCase() || 'A',
    sandwichPresent: Boolean(item.SandWitchPresent ?? item.sandwich_present),
  };
}

export const leaveRulesApi = {
  getRules: async (filters = {}) => {
    const params = {
      search: filters.searchText || undefined,
      status_filter: filters.status || 'Active',
      page: filters.page || 1,
      page_size: filters.pageSize || 10,
    };
    const { data } = await api.get('/payroll/leave-rules/', { params });
    const rawItems = Array.isArray(data?.items) ? data.items : Array.isArray(data) ? data : [];
    return {
      items: rawItems.map(mapRuleHeader),
      total_count: data?.total_count ?? rawItems.length,
      total_pages: data?.total_pages ?? 1,
      page: data?.page ?? (filters.page || 1),
      page_size: data?.page_size ?? (filters.pageSize || 10),
    };
  },

  getLeaveRulesReport: async (filters = {}) => {
    const params = {
      search: filters.searchText || undefined,
      status_filter: filters.status || 'Active',
      page: 1,
      page_size: 1000,
    };
    const { data } = await api.get('/payroll/leave-rules/', { params });
    const rawItems = Array.isArray(data?.items) ? data.items : [];
    return { items: rawItems.map(mapRuleHeader) };
  },

  getRuleById: async (id) => {
    const { data } = await api.get(`/payroll/leave-rules/${id}`);
    return mapRuleHeader(data);
  },

  createRule: async (payload) => {
    const body = { Name: payload.name };
    const { data } = await api.post('/payroll/leave-rules/', body);
    return data;
  },

  updateRule: async (id, payload) => {
    const body = { Name: payload.name };
    const { data } = await api.put(`/payroll/leave-rules/${id}`, body);
    return data;
  },

  archiveRule: async (id) => {
    const { data } = await api.patch(`/payroll/leave-rules/${id}/archive`);
    return data;
  },

  deleteRule: async (id) => {
    const { data } = await api.delete(`/payroll/leave-rules/${id}`);
    return data;
  },

  getRuleDetails: async (ruleId) => {
    const params = ruleId ? { pid: ruleId } : {};
    const { data } = await api.get('/payroll/leave-rules/details/list', { params });
    const items = Array.isArray(data) ? data : [];
    return items.map(mapRuleDetail);
  },

  getRuleDetailById: async (id) => {
    const { data } = await api.get(`/payroll/leave-rules/details/${id}`);
    return mapRuleDetail(data);
  },

  createRuleDetail: async (payload) => {
    const body = {
      PID: Number(payload.ruleId || payload.PID),
      LeaveTypeID: Number(payload.leaveTypeId || payload.LeaveTypeID),
      TotalDays: Number(payload.totalDays || 0),
      MinDays: Number(payload.minDays || 0),
      MaxDays: Number(payload.maxDays || 0),
      CFDays: Number(payload.cfDays || 0),
      Accumulate: payload.accumulate || 'No',
      LapseDays: Number(payload.lapseDays || 0),
      ExtraDays: Number(payload.extraDays || 0),
      Gender: payload.gender || 'A',
      SandWitchPresent: Boolean(payload.sandwichPresent),
    };
    const { data } = await api.post('/payroll/leave-rules/details/', body);
    return data;
  },

  updateRuleDetail: async (id, payload) => {
    const body = {
      LeaveTypeID: payload.leaveTypeId ? Number(payload.leaveTypeId) : undefined,
      TotalDays: payload.totalDays !== undefined ? Number(payload.totalDays) : undefined,
      MinDays: payload.minDays !== undefined ? Number(payload.minDays) : undefined,
      MaxDays: payload.maxDays !== undefined ? Number(payload.maxDays) : undefined,
      CFDays: payload.cfDays !== undefined ? Number(payload.cfDays) : undefined,
      Accumulate: payload.accumulate !== undefined ? payload.accumulate : undefined,
      LapseDays: payload.lapseDays !== undefined ? Number(payload.lapseDays) : undefined,
      ExtraDays: payload.extraDays !== undefined ? Number(payload.extraDays) : undefined,
      Gender: payload.gender || undefined,
      SandWitchPresent: payload.sandwichPresent !== undefined ? Boolean(payload.sandwichPresent) : undefined,
    };
    const { data } = await api.put(`/payroll/leave-rules/details/${id}`, body);
    return data;
  },

  deleteRuleDetail: async (id) => {
    const { data } = await api.delete(`/payroll/leave-rules/details/${id}`);
    return data;
  },

  getLeaveTypeOptions: async () => {
    try {
      const { data } = await api.get('/payroll/leave-master/', { params: { status_filter: 'Active', page_size: 100 } });
      const items = Array.isArray(data?.items) ? data.items : [];
      return items.map((t) => ({
        value: t.ID || t.id,
        label: t.Name || t.name,
        alias: t.Aliase || t.alias || '',
        color: t.ColorCode || t.color || '#3B82F6',
      }));
    } catch {
      return [];
    }
  },
};
